// extracted by mini-css-extract-plugin
export default {"footer":"DpFooter_footer__Y1eCH","error":"DpFooter_error__6Qd0J","close":"DpFooter_close__uCo93","done":"DpFooter_done__6KsXX","now":"DpFooter_now__XUN8-"};